import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["aria-label", "href"]

import Filler from "../../../../shared/Filler.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'action-button',
  props: {
    actionButtonText: {
        type: String,
    },
    productId: Number,
    link: String,
    busy: Boolean,
},
  emits: ["click"],
  setup(__props) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("a", {
    class: _normalizeClass(['action-button', __props.busy ? 'loading' : '']),
    "aria-label": __props.actionButtonText,
    href: __props.link ?? '#',
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('click', $event))),
    "data-product-link": ""
  }, [
    (__props.productId == null)
      ? (_openBlock(), _createBlock(Filler, {
          key: 0,
          max: 12
        }))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createTextVNode(_toDisplayString(__props.actionButtonText), 1 /* TEXT */)
        ], 64 /* STABLE_FRAGMENT */))
  ], 10 /* CLASS, PROPS */, _hoisted_1))
}
}

})